import { Navigate } from "react-router-dom";
import { routes } from "../utils";
import {
  AddEditIncidentCategory,
  AddEditIncidentType,
  BOMBudget,
  BOMReviewBudget,
  BillingCategory,
  IncidentCategory,
  IncidentType,
  InsuranceType,
  OwnerAddEditBudget,
  OwnerAddEditLineItem,
  OwnerLineItems,
  PaymentMethod,
  PaymentTerm,
  PropertyBlock,
  PropertyCategory,
  PropertyModel,
  PropertyZone,
} from "@/pages";
import BomProtectedRoute from "./BomProtectRoute";
import { PermissionGuard } from "@/components";
import { actionsKeys } from "@/lib/utils";

export const MasterDataRoutes = () => {
  return {
    path: routes.masterData,
    element: <BomProtectedRoute />,
    children: [
      {
        path: "",
        element: <Navigate to={`${routes.propertyCategory}`} />,
      },
      {
        path: routes.propertyCategory,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <PropertyCategory />
          </PermissionGuard>
      },
      {
        path: routes.propertyModel,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <PropertyModel />
          </PermissionGuard>
      },
      {
        path: routes.propertyZone,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <PropertyZone />
          </PermissionGuard>
      },
      {
        path: routes.propertyBlock,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <PropertyBlock />
          </PermissionGuard>
      },
      {
        path: routes.insuranceType,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
          <InsuranceType />
        </PermissionGuard>
      },
      {
        path: routes.paymentMethod,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <PaymentMethod />
          </PermissionGuard>
      },
      {
        path: routes.paymentTerm,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <PaymentTerm />
          </PermissionGuard>
      },
      {
        path: routes.billingCategory,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <BillingCategory />
          </PermissionGuard>
      },
      {
        path: routes.budgetApprovals,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.BUDGET}>
                <BOMBudget />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys.BUDGET} action={routes.add}>
                <OwnerAddEditBudget />
              </PermissionGuard>
          },
          {
            path: routes.budgetId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.BUDGET}>
                <OwnerAddEditBudget />
              </PermissionGuard>
          },
          {
            path: routes.budgetId + "/review",
            element: <PermissionGuard moduleKey={actionsKeys.BUDGET} action="view">
                <BOMReviewBudget />
              </PermissionGuard>
          },
          {
            path: routes.budgetId + "/" + routes.lineItems,
            element: <PermissionGuard moduleKey={actionsKeys.BUDGET}>
                <OwnerLineItems />
              </PermissionGuard>
          },
          {
            path:
              routes.budgetId +
              "/" +
              routes.lineItems +
              "/" +
              routes.add,
            element: <PermissionGuard moduleKey={actionsKeys.BUDGET} action={routes.add}>
                <OwnerAddEditLineItem />
              </PermissionGuard>
          },
          {
            path:
              routes.budgetId +
              "/" +
              routes.lineItems +
              "/" +
              routes.lineItemId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.BUDGET}>
                <OwnerAddEditLineItem />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.incidentType,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <IncidentType />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditIncidentType />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditIncidentType />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.incidentCategory,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <IncidentCategory />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditIncidentCategory />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditIncidentCategory />
              </PermissionGuard>
          },
        ],
      },
    ],
  };
};
